// @need-translate
import {TEXT_RESTRICT_IN_PC} from '../../../common/constant';
import {t} from '../../../common/getTranslations';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';
import {ErrorArea} from '../ErrorArea/ErrorArea';

export function NotAvailableOnWeb({
  onClickAppLink,
  isMobile,
}: {
  onClickAppLink: () => void;
  isMobile: boolean;
}) {
  return isMobile ? (
    <ErrorArea isMobile={true}>
      <ErrorArea.Title>{t('web_appdownload_title_ios')}</ErrorArea.Title>
      <ErrorArea.Image type={StaticImageType.ExceptionBiMStatic} />
      <ErrorArea.LabelButton
        onClick={e => LOG_CLICK_EVENT('앱으로열기_클릭', e, onClickAppLink)}
      >
        {t('web_appdownload_button_ios')}
      </ErrorArea.LabelButton>
    </ErrorArea>
  ) : (
    <ErrorArea isMobile={false} isDesignFree={true}>
      <ErrorArea.Image type={StaticImageType.ExceptionBiMStatic} size={100} />
      <ErrorArea.Title className="mt-24pxr">
        {TEXT_RESTRICT_IN_PC}
      </ErrorArea.Title>
      <ErrorArea.PcAppScheme className="mt-40pxr" />
    </ErrorArea>
  );
}
